<template>
  <div>
    <v-row>
      <v-col cols="12" sm="4" align="center">
        <h2>Total Billable Hours</h2>
        <span class="headline">{{ totalBillableHours | formatDecimal }}</span>
      </v-col>
      <v-col cols="12" sm="4" align="center">
        <h2>ST</h2>
        <span class="headline">{{ stHours | formatDecimal }}</span>
      </v-col>
      <v-col cols="12" sm="4" align="center">
        <h2>OT</h2>
        <span class="headline">{{ otHours | formatDecimal }}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: [
    'totalBillableHours',
    'stHours',
    'otHours'
  ]
}
</script>
